<form [formGroup]="formGroup">
  @for (element of elements; track element) {
    @if (element.type === 'text') {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div fxLayout="col" fxFlex="100" class="add-patient-col" fxLayoutAlign="start center">
            <!--  <b class="title">{{ element.title }}</b> -->
            <b class="title">{{ element.title }}</b>
            <!-- Quick Action Button for "Not mentioned" -->
            @if (isInpatientView() || isEOC()) {
              <button nz-button nzType="primary" (click)="setNotMentioned(element.name)" class="quick-button"
                [disabled]="!hasPermission(['a-sqa'])">
                {{ "Not mentioned" | translate }}
              </button>
            }
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <input type="text" class="add-patient-input" [formControlName]="element.name" />
          </div>
        </div>
      </div>
    }
    @if (element.type === 'boolean') {
      <div>
        <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
          <div fxLayout="col" fxFlex="100" class="add-patient-col" fxLayoutAlign="start center">
            <b class="title">{{ element.title }}</b>
          </div>
        </div>
        <div fxLayout="column" fxLayoutAlign="start start" class="add-patient-row radio-button-list">
          <div fxLayout="col" fxFlex="100" class="add-patient-col">
            <label class="radio-label">
              <input type="radio" [formControlName]="element.name" [value]="false"
                (click)="onRadioClick(element.name, false)" /><span>{{ element.labelFalse }}</span>
              </label>
            </div>
            <div fxLayout="col" fxFlex="100" class="add-patient-col">
              <label class="radio-label">
                <input type="radio" [formControlName]="element.name" [value]="true"
                  (click)="onRadioClick(element.name, true)" /><span>{{ element.labelTrue }}</span>
                </label>
              </div>
            </div>
          </div>
        }
        @if (element.type === 'comment') {
          <div>
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div fxLayout="col" fxFlex="100" class="add-patient-col" fxLayoutAlign="start center">
                <b class="title">{{ element.title }}</b>
                <!-- Quick Action Button for "Not mentioned" -->
                @if (isInpatientView() || isEOC()) {
                  <button nz-button nzType="primary" (click)="setNotMentioned(element.name)" class="quick-button"
                    [disabled]="!hasPermission(['a-sqa'])">
                    {{ "Not mentioned" | translate }}
                  </button>
                }
              </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
              <div fxLayout="col" fxFlex="100" class="add-patient-col">
                <textarea class="add-patient-input textarea-input" [formControlName]="element.name"></textarea>
              </div>
            </div>
          </div>
        }
        @if (element.type === 'radiogroup') {
          <div>
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div fxLayout="col" fxFlex="100" class="add-patient-col" fxLayoutAlign="start center">
                <b class="title">{{ element.title }}</b>
              </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="start start" class="add-patient-row radio-button-list">
              @for (choice of element.choices; track choice) {
                <div fxLayout="col" fxFlex="100" class="add-patient-col">
                  <label class="radio-label">
                    <input type="radio" [formControlName]="element.name" [value]="choice.value"
                      (click)="onRadioClick(element.name, choice.value)" /><span>{{ choice.text }}</span>
                    </label>
                  </div>
                }
              </div>
            </div>
          }
        }
      </form>